import { Loader2 } from 'lucide-react';
import type { ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import { Dialog } from '@/components/ui/dialog';

type ConfirmDialogProperties = {
  confirmLabel?: string;
  description?: ReactNode;
  isPending?: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  pendingLabel?: string;
  title: string;
  variant?: 'danger' | 'primary' | 'secondary';
};

export const ConfirmDialog = ({
  confirmLabel = 'Confirm',
  description,
  isPending = false,
  onConfirm,
  onOpenChange,
  open,
  pendingLabel = 'Working…',
  title,
  variant = 'primary',
}: ConfirmDialogProperties) => (
  <Dialog description={description} onOpenChange={onOpenChange} open={open} title={title}>
    <div className="flex justify-end gap-2">
      <Button disabled={isPending} onClick={() => onOpenChange(false)} variant="secondary">
        Cancel
      </Button>
      <Button aria-busy={isPending} disabled={isPending} onClick={onConfirm} variant={variant}>
        {isPending ? <Loader2 aria-hidden="true" className="size-4 animate-spin" /> : null}
        {isPending ? pendingLabel : confirmLabel}
      </Button>
    </div>
  </Dialog>
);
